import { render, staticRenderFns } from "./RegionMappingsView.vue?vue&type=template&id=11d6fc65&scoped=true"
import script from "./RegionMappingsView.vue?vue&type=script&lang=js"
export * from "./RegionMappingsView.vue?vue&type=script&lang=js"
import style0 from "./RegionMappingsView.vue?vue&type=style&index=0&id=11d6fc65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d6fc65",
  null
  
)

export default component.exports